export default "__VITE_ASSET__531a2fa9__"